import { useSprintMutation, useSprintQueryClient, SprintMutationResult } from "sprint-common-web";

import { UpdateOnPremAssetLibraryRequest } from "../../../../../common/api/master-api/assets/details/UpdateOnPremAssetLibraryRequest";
import { UpdateOnPremAssetLibraryResponse } from "../../../../../common/api/master-api/assets/details/UpdateOnPremAssetLibraryResponse";
import { useAssetsApi } from "../../../../../common/api/master-api/assets/useAssetsApi";
import { OnPremAssetQueryKey } from "../../common/OnPremAssetQueryKey";

export interface UseEditOnPremAssetLibrary {
    updateOnPremAssetLibrary: SprintMutationResult<UpdateOnPremAssetLibraryRequest, UpdateOnPremAssetLibraryResponse>;
}

export const useEditOnPremAssetLibrary = ({
    invalidationKey
}: {
    invalidationKey?: string;
}): UseEditOnPremAssetLibrary => {
    const assetsApi = useAssetsApi();
    const sprintQueryClient = useSprintQueryClient();

    const updateOnPremAssetLibrary = useSprintMutation<
        UpdateOnPremAssetLibraryRequest,
        UpdateOnPremAssetLibraryResponse
    >({
        mutationFn: async ({ assetId, filePath }: UpdateOnPremAssetLibraryRequest) => {
            if (!assetId) {
                throw new Error("Asset ID is required to update asset library details.");
            }

            return assetsApi.updateOnPremAssetLibrary({
                assetId,
                filePath
            });
        },
        onSettled: async () => {
            await sprintQueryClient.invalidateQueries({
                queryKey: [OnPremAssetQueryKey.OnPremAssetDetails, invalidationKey]
            });
        }
    });

    return {
        updateOnPremAssetLibrary
    };
};
